import { render } from "./Datasource.vue?vue&type=template&id=b20250e0"
import script from "./Datasource.vue?vue&type=script&lang=js"
export * from "./Datasource.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__